import { Fragment, useContext, useEffect, useState } from "react";
import { BreadCrumb } from "../../Layout/Common/breadCrumb";
import { GlobalContext } from "../../Context/GlobalContext";
import { useNavigate, Link } from "react-router-dom";
import { ConvertToFloat, scrollToTop } from "../../Layout/Common/common";
import { PAGES } from "../../routeConfig";
import { useAuth } from "../../Context/AuthContext";

export const MyAccount = () => {
  const globalcontext = useContext(GlobalContext);
  const { role, isBrowseOnly } = useAuth();

  useEffect(() => {}, [role]);

  return (
    <Fragment>
      <BreadCrumb data={[{ name: "My Account", url: "" }]} />
      <>
        <section className="myAccount-section">
          <div className="container-fluid container-lg">
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="myaccount-overview">
                  {/* My Orders — hidden for browse-only users */}
                  {!isBrowseOnly && (
                    <div className="myAcc-list">
                      <h2>My Orders</h2>
                      <div className="row row-spacing-account">
                        {/* Order History */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3 mt-lg-0">
                          <Link to={PAGES.ORDERHISTORY}>
                            <div className="myAccount-list">
                              <div className="myAccount-list-img">
                                <img
                                  src="https://cdn.wes.com.au/wesreact/newui/img/my-account/order-history.svg"
                                  alt="Order History"
                                />
                              </div>
                              <div className="myAccount-list-content">
                                <h4>Order History</h4>
                                <p>Track Orders, Check Order Status, and view order history</p>
                              </div>
                            </div>
                          </Link>
                        </div>
                        {/* Order History */}
                        {/* My Favourite Products */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3 mt-lg-0">
                          <Link to={PAGES.FAVORITEPRODUCT_LIST}>
                            <div className="myAccount-list">
                              <div className="myAccount-list-img">
                                <img
                                  src="https://cdn.wes.com.au/wesreact/newui/img/my-account/favorite-product.svg"
                                  alt="Favourite Products"
                                />
                              </div>
                              <div className="myAccount-list-content">
                                <h4>My Favourite Products</h4>
                                <p>Save products to lists for project management or quick reordering</p>
                              </div>
                            </div>
                          </Link>
                        </div>
                        {/* My Favourite Products */}
                        {/* Pending Orders */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3 mt-lg-0">
                          <Link to={PAGES.PENDINGORDERS}>
                            <div className="myAccount-list">
                              <div className="myAccount-list-img">
                                <img
                                  src="https://cdn.wes.com.au/wesreact/newui/img/my-account/pending-orders.svg"
                                  alt="Pending Orders"
                                />
                              </div>
                              <div className="myAccount-list-content">
                                <h4>Pending Orders</h4>
                                <p>Review user-created orders and submit for processing</p>
                              </div>
                            </div>
                          </Link>
                        </div>
                        {/* Pending Orders */}
                      </div>
                    </div>
                  )}
                  {/* My Orders */}
                  {/* My Account */}
                  <div className="myAcc-list">
                    <h2>My Account</h2>
                    <div className="row row-spacing-account row-equal-coloumn">
                      <div className="col-6 col-sm-6 col-md-4 col-lg-3 mb-3 mt-3 mt-lg-0">
                        <Link to={PAGES.MYACCOUNTDETAIL}>
                          <div className="myAccount-list">
                            <div className="myAccount-list-img">
                              <img
                                src="https://cdn.wes.com.au/wesreact/newui/img/my-account/account-details.svg"
                                alt="Account Details"
                              />
                            </div>
                            <div className="myAccount-list-content">
                              <h4>My Account Details</h4>
                              <p>View your shipping and billing address details</p>
                            </div>
                          </div>
                        </Link>
                      </div>

                      {!isBrowseOnly && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3  mb-3  mt-lg-0">
                          <Link to={PAGES.MYWALLET}>
                            <div className="myAccount-list">
                              <div className="myAccount-list-img">
                                <img
                                  src="https://cdn.wes.com.au/wesreact/newui/img/my-account/my-wallet.svg"
                                  alt="My Wallet"
                                />
                              </div>
                              <div className="myAccount-list-content">
                                <h4>My Wallet</h4>
                                <p>Save cards for a faster checkout experience</p>
                              </div>
                            </div>
                          </Link>
                        </div>
                      )}
                      {!isBrowseOnly && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3  mb-3  mt-lg-0">
                          <Link to={PAGES.PAYACCOUNT}>
                            <div className="myAccount-list">
                              <div className="myAccount-list-img">
                                <img
                                  src="https://cdn.wes.com.au/wesreact/newui/img/my-account/pay-account.svg"
                                  alt="My Wallet"
                                />
                              </div>
                              <div className="myAccount-list-content">
                                <h4>Pay Account</h4>
                                <p>Pay Invoices awaiting payment</p>
                              </div>
                            </div>
                          </Link>
                        </div>
                      )}

                      {role == 1 && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3  mb-3  mt-3 mt-lg-0">
                          <Link to={PAGES.COMPANYUSER}>
                            <div className="myAccount-list">
                              <div className="myAccount-list-img">
                                <img
                                  src="https://cdn.wes.com.au/wesreact/newui/img/my-account/company-users.svg"
                                  alt="company users"
                                />
                              </div>
                              <div className="myAccount-list-content">
                                <h4>My Company Users</h4>
                                <p>Add or update multiple user logins for your account</p>
                              </div>
                            </div>
                          </Link>
                        </div>
                      )}

                      {!isBrowseOnly && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3  mb-3 mt-lg-0">
                          <Link to={PAGES.MYADDRESSBOOK}>
                            <div className="myAccount-list">
                              <div className="myAccount-list-img">
                                <img
                                  src="https://cdn.wes.com.au/wesreact/newui/img/my-account/address-book.svg"
                                  alt="Address Book"
                                />
                              </div>
                              <div className="myAccount-list-content">
                                <h4>Shipping Address Book</h4>
                                <p>View Your Shipping and billing address details</p>
                              </div>
                            </div>
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* My Account */}
                  {/* Settings */}
                  <div className="myAcc-list">
                    <h2>Settings</h2>
                    <div className="row row-spacing-account">
                      {/* Website Settings */}
                      {!isBrowseOnly && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3 mt-lg-0">
                          <Link to={PAGES.WEBSITESETTING}>
                            <div className="myAccount-list">
                              <div className="myAccount-list-img">
                                <img
                                  src="https://cdn.wes.com.au/wesreact/newui/img/my-account/website-settings.svg"
                                  alt="website settings"
                                />
                              </div>
                              <div className="myAccount-list-content">
                                <h4>Website Settings</h4>
                                <p>Customise your experience with specific settings</p>
                              </div>
                            </div>
                          </Link>
                        </div>
                      )}
                      {/* Website Settings */}
                      {/* Change Password */}
                      <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3 mt-lg-0">
                        <Link to={PAGES.CHANGEPASSWORD}>
                          <div className="myAccount-list">
                            <div className="myAccount-list-img">
                              <img
                                src="https://cdn.wes.com.au/wesreact/newui/img/my-account/change-pwd.svg"
                                alt="Change Password"
                              />
                            </div>
                            <div className="myAccount-list-content">
                              <h4>Change Password</h4>
                              <p>Reset your account password</p>
                            </div>
                          </div>
                        </Link>
                      </div>
                      {/* Change Password */}
                      {/* Change Username */}
                      <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3 mt-lg-0">
                        <Link to={PAGES.CHANGEUSERNAME}>
                          <div className="myAccount-list">
                            <div className="myAccount-list-img">
                              <img
                                src="https://cdn.wes.com.au/wesreact/newui/img/my-account/change-username.svg"
                                alt="Change Username"
                              />
                            </div>
                            <div className="myAccount-list-content">
                              <h4>Change Username</h4>
                              <p>Reset your account username</p>
                            </div>
                          </div>
                        </Link>
                      </div>
                      {/* Change Username */}
                    </div>
                  </div>
                  {/* Settings */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* My Account Overview Section */}
      </>
    </Fragment>
  );
};
